import type { BlockId, BlockStateUnionType, BlockType } from '@unifyapps/defs/types/block';
import _pick from 'lodash/pick';
import { nextBlockStateKeys } from '../../builder/actions/updateBlock/getUpdateBlockStateByActiveDeviceAction';
import type { InterfaceStoreStateGetterAndSetter } from '../types';

export type UpdateBlockForActiveDeviceActionProps = {
  blockId: BlockId;
  block: BlockType;
};

export const getUpdateBlockForActiveDeviceAction =
  (storeArgs: InterfaceStoreStateGetterAndSetter) =>
  (args: UpdateBlockForActiveDeviceActionProps) => {
    const { updateBlockState, registry } = storeArgs;
    const { blockId, block } = args;
    if (!blockId) return;

    const nextBlockState = registry.getBlockInitialState(block.component.componentType, block);

    if (nextBlockState) {
      updateBlockState(blockId, (draft) => {
        Object.assign(draft as BlockStateUnionType, _pick(nextBlockState, nextBlockStateKeys));
      });
    }
  };
